<div class="full-screen-dialog">
  <button class="close-button" [mat-dialog-close]>
    <svg-icon-sprite [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'24px'">
    </svg-icon-sprite>
  </button>
  <h1 class="px-heading-3">Add new user</h1>
  <div class="add-user">
    <form novalidate [formGroup]="addUserForm" (ngSubmit)="addUserSubmit()">
      <div class="d-flex nxt-input-wrap">
        <div class="nxt-input pl-0">
          <mat-label class="nxt-label">Email ID <span class="asterisk">*</span></mat-label>
          <div class="nxt-input-infix">
            <mat-form-field appearance="outline" class="w-100 col-lg-12 p-0 mb-4" [hideRequiredMarker]="true">
              <input matInput [type]="'email'" formControlName="email" placeholder="Email"
                (input)="validateEmail($event.target.value)">
              <div *ngIf="emailExist" class="exist-error">
                Email already exists
              </div>

              <mat-error
                *ngIf="addUserForm.get('email').hasError('required') && addUserForm.controls['email'].touched">
                Email id is required
              </mat-error>
              <mat-error
                *ngIf="addUserForm.get('email').value && addUserForm.get('email').hasError('invalidEmail') && addUserForm.controls['email'].touched">
                Please enter valid email
              </mat-error>
              <mat-error
                *ngIf="addUserForm.get('email').hasError('invalidCharError') && addUserForm.controls['email'].touched">
                Only numbers (0-9), letters(a-z, A-Z), "_" and "-" characters are allowed
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="nxt-input">
          <mat-label class="nxt-label">Account type <span class="asterisk">*</span></mat-label>
          <div class="nxt-input-infix">
            <mat-form-field appearance="outline" class="w-100">
              <mat-select formControlName="sso"
                [class.singleSelect]="selectAccountType && selectAccountType.length=== 1" class="select-box">
                <mat-option *ngFor="let type of selectAccountType" value="{{type.value}}">{{type.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="clearfix"></div>

      <div class="vendor-submit-btn">
        <button class="px-primary-btn-xs text-uppercase mt-5" color="primary"
          [disabled]="addUserForm.invalid || emailExist">Add</button>
      </div>
    </form>
  </div>
</div>
